import { render, staticRenderFns } from "./StoryblokImage.vue?vue&type=template&id=04b763fa&scoped=true&"
import script from "./StoryblokImage.vue?vue&type=script&lang=ts&"
export * from "./StoryblokImage.vue?vue&type=script&lang=ts&"
import style0 from "./StoryblokImage.vue?vue&type=style&index=0&id=04b763fa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04b763fa",
  null
  
)

export default component.exports